import { SessionProvider } from '@/components/livekit/app/session-provider';
import { ViewController } from '@/components/livekit/app/view-controller';
import { Toaster } from '@/components/livekit/livekit/toaster';

import { LIVEKIT_CONFIG_DEFAULTS } from '@/lib/livekit';

import { RoomAudioRenderer, StartAudio } from '@livekit/components-react';

function Livekit() {
  const appConfig = LIVEKIT_CONFIG_DEFAULTS;

  return (
    <SessionProvider appConfig={appConfig}>
      <ViewController />
      <StartAudio label="Start Audio" />
      <RoomAudioRenderer />
      <Toaster />
    </SessionProvider>
  );
}

export default Livekit;
